import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_assurance_that_workers_contractors_who_enter_confined_1'

export const dataPointDefinition = {
  retracedId: 'no_assurance_that_workers_contractors_who_enter_confined_1',
  name: 'No assurance that workers/contractors who enter confined spaces do so only when appropriate measures have been taken to ',
  description:
    'Select "Not applicable" if the facility has not conducted a confined space entry (CSE) in the assessment period.',
  meta: {
    slcpMeta: {
      key: 'hs-bui-50x',
      number: 'HS-BUI-13-4',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-46',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-13,Yes',
      machineShowHide: '[2],hs-13,1',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'hs-bui-46',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-50x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29780,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
